import { memo, useEffect, useState } from "react";

import { Layout } from "components/Layout";
import { useDebounce } from "hooks/useDebounce";
import { IConditionInfo, ISociometryCondition } from "shared/types/condition";
import { BackButton } from "components/BackButton";
import { SuitableMethodsList } from "components/methods/SuitableMethodsList";
import { Info } from "components/Info";
import { conditions } from "../consts/conditions";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showAlert } from "redux/actions/setAppActions";

interface MethodsSociometryProps {
    className?: string;
}

export const MethodsSociometry = memo((props: MethodsSociometryProps) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [filteredConditions, setFilteredConditions] = useState<ISociometryCondition[]>([]);
    const [info, setInfo] = useState<IConditionInfo | null>(null);
    const [searchField, setSearchField] = useState("");
    const debouncedValue = useDebounce(searchField, 500);

    useEffect(() => {
        if (conditions?.length) {
            if (debouncedValue.trim()) {
                const regex = new RegExp(debouncedValue, "i");
                const filter = conditions.filter(
                    ({ name, methodAuthor }) => regex.test(name) || regex.test(methodAuthor),
                );

                setFilteredConditions(filter);
            } else {
                setFilteredConditions(conditions);
            }
        }
    }, [conditions, debouncedValue]);

    const searchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchField(e.target.value);
    };

    const showInfoHandler = (e: React.MouseEvent, condition: ISociometryCondition) => {
        if (!info) {
            e.stopPropagation();

            setInfo({
                name: condition.name,
                desc: condition.message,
                conditionId: condition._id,
                author: condition.methodAuthor,
                desTeacher: condition.desTeacher,
                message: condition.message,
            });
        } else {
            setInfo(null);
        }
    };

    const sendTestHandler = (condition: ISociometryCondition) => {
        if (condition) {
            history.push(`/sociometry/tests/create`);
        } else {
            dispatch(showAlert({ type: "error", text: "Тест не найден" }));
        }
    };

    if (info) {
        return (
            <Layout>
                <Info
                    name={info.name}
                    handler={showInfoHandler}
                    conditionId={info.conditionId}
                    author={info.author}
                    desTeacher={info.desTeacher}
                    message={info.message}
                    scales={info.scales}
                    sendTestHandler={sendTestHandler}
                    showQuestions={false}
                />
            </Layout>
        );
    }

    return (
        <Layout>
            <div className="page full-header">
                <header className="page__header full-header">
                    <BackButton />
                    <p className="page__title">Социометрия</p>
                </header>

                <SuitableMethodsList
                    debouncedValue={debouncedValue}
                    filteredConditions={filteredConditions}
                    searchField={searchField}
                    searchHandler={searchHandler}
                    sendTestHandler={sendTestHandler}
                    showInfoHandler={showInfoHandler}
                    isSociometry
                />
            </div>
        </Layout>
    );
});

MethodsSociometry.displayName = "MethodsSociometry";
